// Lightweight event bus for cross-layer session signalling.
// The axios interceptor and websocket handlers (outside React)
// can dispatch these events for React UI containers to consume.

const SESSION_401_EVENT = "session:401";
const USER_BLOCKED_EVENT = "user:blocked";
const TOKEN_REFRESHED_EVENT = "auth:token-refreshed";

export const emitSession401 = () => {
  window.dispatchEvent(new CustomEvent(SESSION_401_EVENT));
};

export const onSession401 = (handler) => {
  window.addEventListener(SESSION_401_EVENT, handler);
  return () => window.removeEventListener(SESSION_401_EVENT, handler);
};

export const emitUserBlocked = (detail = {}) => {
  window.dispatchEvent(new CustomEvent(USER_BLOCKED_EVENT, { detail }));
};

export const onUserBlocked = (handler) => {
  window.addEventListener(USER_BLOCKED_EVENT, handler);
  return () => window.removeEventListener(USER_BLOCKED_EVENT, handler);
};

export const emitTokenRefreshed = (detail = {}) => {
  window.dispatchEvent(new CustomEvent(TOKEN_REFRESHED_EVENT, { detail }));
};

export const onTokenRefreshed = (handler) => {
  window.addEventListener(TOKEN_REFRESHED_EVENT, handler);
  return () => window.removeEventListener(TOKEN_REFRESHED_EVENT, handler);
};
